import React from 'react';
import { Link } from 'react-router-dom';
import { formatMoney, pricePerCan } from '../../lib/shopify';
import { AddToCart } from './AddToCart';
import { RestockNotify } from './RestockNotify';
import type { Product } from '../../types/commerce';
export function ProductCard({
  product
}: {
  product: Product;
}) {
  return <article className="flex h-full flex-col" data-id="element-247" data-mp="1jbvmyybltahu">
      <Link to={`/product/${product.handle}`} className="group relative block overflow-hidden rounded-3xl bg-white/5" aria-label={`${product.name} ${product.packLabel}`} data-id="element-248" data-mp="1jb3s5pptzgsm">
        <div className="aspect-[4/5] w-full overflow-hidden" data-id="element-249" data-mp="272izjwwgsoaq">
          <div className="h-full w-full" style={{
          transform: `scale(${product.imageZoom ?? 1})`,
          transformOrigin: product.imageFocus ?? 'center'
        }} data-id="element-250" data-mp="271zi0haq81x8">
            <img src={product.images[0]} alt={`${product.name} ${product.packLabel}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" style={{
            transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)'
          }} data-id="element-251" data-mp="cqba2z2wwzmc" />
          </div>
        </div>
        {product.badge && <span className="absolute left-4 top-4 rounded-full bg-beat-black/80 px-3 py-1.5 text-xs font-medium uppercase tracking-widest text-white backdrop-blur" data-id="element-252" data-mp="3vgwaopey5e9v">
            {product.badge}
          </span>}
      </Link>

      <div className="mt-6 flex flex-1 flex-col" data-id="element-253" data-mp="8bdpi5dbdgns">
        <div className="flex items-start justify-between gap-4" data-id="element-254" data-mp="8e9olx0webdt">
          <h3 className="text-xl font-medium tracking-tight" data-id="element-255" data-mp="dckzmb2xirxm">
            {product.name}
            <span className="ml-2 text-white/40" data-id="element-256" data-mp="i9bfoyeqhnj1">{product.packLabel}</span>
          </h3>
          <p className="shrink-0 text-lg font-medium tabular-nums" data-id="element-257" data-mp="2f3el1ezlm3dj">
            {formatMoney(product.price.amount, product.price.currencyCode)}
          </p>
        </div>

        <p className="mt-2 max-w-sm text-base leading-relaxed text-white/55" data-id="element-258" data-mp="2c11qjjlvt1y2">
          {product.tagline}
        </p>

        <p className="mt-3 text-sm text-white/40" data-id="element-259" data-mp="272gl95rrvs2r">
          {product.cans} cans · {pricePerCan(product)} per can
        </p>

        {product.availableForSale ? <div className="mt-auto flex flex-wrap items-center gap-3 pt-6" data-id="element-260" data-mp="2lwuzkt0e6db3">
            <AddToCart product={product} data-id="element-261" data-mp="2gytek2jeo3wz" />
            <Link to={`/product/${product.handle}`} className="inline-flex min-h-[52px] items-center text-base font-medium text-white/60 transition-colors duration-150 hover:text-white" data-id="element-262" data-mp="2uzmdczgqpl5w">
              View product
            </Link>
          </div> : <div className="mt-auto pt-6" data-id="element-263" data-mp="2zq2pmg8tr0qo">
            <RestockNotify product={product} data-id="element-264" data-mp="2zr4f3pql7prx" />
            <Link to={`/product/${product.handle}`} className="mt-4 inline-flex min-h-[44px] items-center text-base font-medium text-white/60 transition-colors duration-150 hover:text-white" data-id="element-265" data-mp="3dq42yv6a00n1">
              View product
            </Link>
          </div>}
      </div>
    </article>;
}